import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import makeStyles from '@material-ui/core/styles/makeStyles';
import MuiAlert from '@material-ui/lab/Alert';

import { useAlertText, useAlertType, useIsAlertOpen, useGDirection } from '../hooks';

const Alert: React.FC = () => {
    const mediaQuery = useMediaQuery('(max-width: 500px)');

    const classes = useStyles();

    const [isOpen, setIsOpen] = useIsAlertOpen();
    const [text] = useAlertText();
    const [type] = useAlertType();

    const direction = useGDirection()

    return (
        <Snackbar
            open={isOpen}
            autoHideDuration={6000}
            className={classes.snackbar}
            onClose={() => setIsOpen(false)}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: mediaQuery ? 'center' : direction === "rtl" ? 'right' : 'left'
            }}
        >
            <MuiAlert
                variant="filled"
                severity={type}
                className={classes.alert}
                onClose={() => setIsOpen(false)}
            >
                {text}
            </MuiAlert>
        </Snackbar>
    );
}

const useStyles = makeStyles(theme => ({
    snackbar: {
        [theme.breakpoints.down(500)]: {
            margin: '3vw 2vw'
        }
    },

    alert: {
        boxShadow: 'gray 0 3px 6px',
        alignItems: 'center',

        [theme.breakpoints.down(500)]: {
            fontSize: '5vw'
        }
    }
}));

export default Alert;